<template>
    <section class="section reglasView">
        <h1 class="title is-4 has-text-centered is-hidden-desktop"><font-awesome-icon icon="book-open"/> Reglamento</h1>
        <Panel title="Descripción del juego en quinielazo">
            <div class="panel-block">
                <div class="content">
                    <ol>
                        <li>Quinielazo.com es un juego de apuestas en linea que se maneja con puntos virtuales adquiridos solamente en quinielazo.com.</li>
                        <li>
                            Quinielazo.com cuenta con dos modos de juego:
                            <ul>
                                <li><strong>Modo Parlay:</strong> Se eligen de 2 a 8 partidos, el premio es la suma de los momios de acuerdo el resultado indicado por el usuario por la cantidad de puntos apostada. El premio lo paga quinielazo.</li>
                                <li><strong>Modo Amigos:</strong> Se eligen de 2 a N partidos, se invitan amigos inscritos en la red social a participar en la quiniela, el premio aumenta por cada invitado que acepte entrar a la quiniela. El premio es el acumulado de los puntos apostados por los integrantes de la quiniela.</li>
                            </ul>
                        </li>
                        <li>Quinielazo.com sera el encargado semana a semana de integrar al sitio la lista de partidos que el usuario tendra disponible para sus quinielas, por su parte cada usuario tendra la libertad de escoger los partidos que desee jugar ya sea en modo "parlay" o contra sus "amigos"</li>
                        <li>La lista de partidos disponible para quinielas aparecera en la pagina principal del sitio detallando oportunamente la información de los encuentros asi como la fecha y hora.</li>
                        <li>La manera de ganar el premio en cada modo de juego es la siguiente:
                            <ul>
                                <li><strong>Modo Parlay:</strong> Se tienen que cumplir todas las predicciones que indico el jugador en su parlay para poder llevarse el premio.</li>
                                <li><strong>Modo Amigos:</strong> En este modo no es necesario adivinar todos los resultados, el usuario o invitado que logre tener mas aciertos en la lista de partidos de la quiniela se llevara el premio acumulado de puntos, en caso de haber un empate en la cantidad de aciertos se reparte el premio en partes iguales con los ganadores.</li>
                            </ul>
                        </li>
                        <li>Las quinielas se pondran en juego en la fecha que inicie el 1er partido de la quiniela, una vez entrando en el estado "En juego" no sera posible que un invitado ingrese a participar dentro de esta quniela, ni que un integrante pueda invitar a mas amigos(invitados)</li>
                        <li>Una quiniela o parlay se termina al momento en que todos los partidos que esta incluye son terminados de manera oficial.</li>
                        <li>Se tomara como resultado definitivo la cantidad de goles en el encuentro (90 minutos reglamentarios y tiempos extras si asi lo requiere) excluyendo penalties para efectos de determinar al equipo ganador o empate</li>
                        <li>En caso de llevarse acabo la cancelacion de un encuentro el partido se definira como un empate</li>
                        <li>En caso de posponerse para otra fecha un encuentro la quiniela quedara en juego, hasta que este se lleve acabo</li>
                        <li>La modificacion en la fecha y horario de un partido por parte de las autoridades oficiales deportivas puede llevarse a cabo en cualquier momento</li>
                        <li>Si un partido es suspendido despues de haber empezado y el resultado definitivo no se da a conocer antes del cierre semanal se tomara el marcador parcial de este para sacar el resultado</li>
                        <li>Cualquier persona puede participar en quinielazo.com, cumpliendo el unico requisito de registrarse en el sitio y contar con un correo electronico valido.</li>
                        <li>La cantidad mínima para cualquier apuesta son 100 puntos</li>
                    </ol>
                </div>
            </div>
        </Panel>
    </section>
</template>

<script>
    import Panel from '@/components/Panel'
    export default {
        components: { Panel },
        name: 'Reglas',
        metaInfo(){
			return {
				title: 'Reglamento | Quinielazo.com'
			}
		}
    }
</script>

<style scoped>
    .reglasView{
        padding: 1rem 1rem;
    }
    .panel-block{
        padding: 1.5em 1em;
    }
    ol,ul{
        margin-left: 2em;
    }
    li{
        line-height: 1.7em;
    }
</style>